import {createReducer, on} from "@ngrx/store";
import {CoreEnvironmentService} from "@core/services/environment/core-environment.service";
import {SharedNotificationListState} from "@shared/components/notification-list/store/shared-notification-list.state";
import {SharedNotificationListActions} from "./shared-notification-list.actions-type";

function getInitialNotificationListState(): SharedNotificationListState {
  const env = CoreEnvironmentService.getEnvironment();
  return {
    notificationList: {
      paging: {
        totalItems: 0,
        pageNumber: 0,
        pageSize: env?.apiUrl?.pageDefaultSize || 50,
        totalPages: 1
      },
      items: [],
      filters: []
    },
    notificationSettings: undefined,
    isLoading: false,
  }
}

export const sharedNotificationListStore = createReducer(
  getInitialNotificationListState(),
  on(SharedNotificationListActions.getNotificationList, (state) => ({
    ...state,
    isLoading: true
  })),
  on(SharedNotificationListActions.getNotificationListSuccess, (state, { filters, paging, items }) => ({
    ...state,
    notificationList: {
      filters: filters ?? [],
      paging: paging,
      items: paging.pageNumber === 1 ? items : [...state.notificationList.items, ...items]
    },
    isLoading: false
  })),
  on(SharedNotificationListActions.getNotificationListFail, (state) => ({
    ...state,
    isLoading: false
  })),
  on(SharedNotificationListActions.notificationPollingSuccess, (state, { count }) => ({
    ...state,
    notificationList: {
      ...state.notificationList,
      paging: {
        ...state.notificationList.paging,
        totalItems: count
      }
    }
  })),
  on(SharedNotificationListActions.getNotificationSettings, (state) => ({
    ...state,
    isLoading: true
  })),
  on(SharedNotificationListActions.getNotificationSettingsSuccess, (state, { settings }) => ({
    ...state,
    notificationSettings: settings,
    isLoading: false
  })),
  on(SharedNotificationListActions.getNotificationSettingsFail, (state) => ({
    ...state,
    isLoading: false
  })),
  on(SharedNotificationListActions.setGlobalNotificationAllowance, (state) => ({
    ...state,
    isLoading: true
  })),
  on(SharedNotificationListActions.setGlobalNotificationAllowanceSuccess, (state, { settings }) => ({
    ...state,
    notificationSettings: settings,
    isLoading: false
  })),
  on(SharedNotificationListActions.setGlobalNotificationAllowanceFail, (state) => ({
    ...state,
    isLoading: false
  })),
  on(SharedNotificationListActions.setNotificationAllowanceForSubject, (state) => ({
    ...state,
    isLoading: true
  })),
  on(SharedNotificationListActions.setNotificationAllowanceForSubjectSuccess, (state, { settings }) => ({
    ...state,
    notificationSettings: settings,
    isLoading: false
  })),
  on(SharedNotificationListActions.setNotificationAllowanceForSubjectFail, (state) => ({
    ...state,
    isLoading: false
  })),
);
